module.exports = __webpack_public_path__ + "img/four-eight.b14ff7ed.png";